import classnames from 'classnames';
import { GatsbyImage } from "gatsby-plugin-image";
import React from 'react';

import Link from '../UI/Link/Link';
import * as styles from './ConsultantCard.module.scss';

const ConsultantCard = ({
  photo,
  title,
  jobTitle,
  specialities,
  path,
}) => {
  const className = classnames(styles.container, {});

  return (
    <article className={className}>
      {photo ? (
        <GatsbyImage
          image={photo?.localFile?.childImageSharp?.gatsbyImageData}
          className={styles.photo} />
      ) : (
        <div className={styles.photo}/>
      )}
      
      <h3 className={styles.title}>
        <Link to={path}>{title}</Link>
      </h3>
      {jobTitle && 
         <p className={styles.jobTitle}>{jobTitle}</p>
      }
      {!!specialities.nodes?.length && (
        <p className={styles.specialities}>
          {specialities.nodes?.map(({ name }) => name).join(', ')}
        </p>
      )}
    </article>
  );
};

export default ConsultantCard;
